var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1 1)",
    d: "M197.00061 99.046997C196.00432 99.016418 195.0042 99.001015 194.00049 99.001015C140.98116 99.001015 98.000488 141.98167 98.000488 195.00101C98.000488 195.66971 98.007324 196.33681 98.020927 197.00224L98.019997 197.00101L97.980064 197.00124L0.00048593557 197.00101L97.980064 197.00124C97.993652 196.33614 98.000488 195.66937 98.000488 195.00101L97.987625 193.41348C97.13987 141.12636 54.489628 99.001015 2.0004859 99.001015C1.3320396 99.001015 0.66518897 99.007843 -1.9617769e-14 99.021439L-8.1604975e-15 98.980583C0.66518897 98.994179 1.3320396 99.001015 2.0004859 99.001015C55.019821 99.001015 98.000488 56.020348 98.000488 3.0010118C98.000488 1.9970002 97.985077 0.99658829 97.954468 -1.2454248e-14L97.954002 0.001L98.107407 0.0012128763L197.00049 0.0010119183L98.107407 0.0012128763C98.036392 1.4923691 98.000488 2.992563 98.000488 4.5010118C98.000488 56.691921 140.98116 99.001015 194.00049 99.001015C195.0042 99.001015 196.00432 98.985847 197.00061 98.955742L197.00061 99.046997Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbol);
export default __webpack_public_path__ + "static/media/logo-symbol.ba4d3452d3c84971332e088958f6a86a.svg";
export { ForwardRef as ReactComponent };